module.exports = __webpack_public_path__ + "vip-shipping.cdc4ab0a01bfbc794bb2daee328b4e8a.svg";